/* ============================================================
   KENSUI • KSU-PICKER — generic guided variant picker engine
   Config-driven: question copy, branch logic and SKU maps live in
   window.KSUPickerConfigs[<id>] (see ksu-picker-config-swissies.liquid).
   This file knows nothing about any specific product line.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Currency (existing KENSUI pattern) ---------- */
  var CURRENCY_LOCALE = {
    USD: 'en-US', CAD: 'en-CA', AUD: 'en-AU', NZD: 'en-NZ', GBP: 'en-GB',
    EUR: 'en-IE', JPY: 'ja-JP', CNY: 'zh-CN', HKD: 'en-HK', SGD: 'en-SG',
    KRW: 'ko-KR', INR: 'en-IN', CHF: 'de-CH', SEK: 'sv-SE', NOK: 'nb-NO',
    DKK: 'da-DK', PLN: 'pl-PL', CZK: 'cs-CZ', AED: 'ar-AE', SAR: 'ar-SA',
    ZAR: 'en-ZA', BRL: 'pt-BR', MXN: 'es-MX', ILS: 'he-IL', TRY: 'tr-TR'
  };
  var ZERO_DECIMAL = { JPY: 1, KRW: 1, VND: 1, CLP: 1, ISK: 1, HUF: 1, TWD: 1, XOF: 1, XAF: 1 };

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }
  function formatPrice(cents) {
    var cur = activeCurrency();
    var locale = CURRENCY_LOCALE[cur] || 'en-US';
    var zero = !!ZERO_DECIMAL[cur];
    var amount = cents / 100;
    try {
      /* whole amounts drop the trailing .00; fractional keep both decimals */
      var whole = zero || cents % 100 === 0;
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: zero ? 0 : 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }
  function flagEmoji(code) {
    if (!code || code.length !== 2) return '';
    var c = code.toUpperCase(), a = c.charCodeAt(0), b = c.charCodeAt(1);
    if (a < 65 || a > 90 || b < 65 || b > 90) return '';
    return String.fromCodePoint(0x1F1E6 + a - 65, 0x1F1E6 + b - 65);
  }

  /* ---------- Small helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>';
  var SHIELD_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>';

  /* ---------- Analytics / Klaviyo ---------- */
  function ga(eventName, params) {
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, params || {}); } catch (e) { /* no-op */ }
    }
  }
  function klaviyoPush(payload) {
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(payload);
    } catch (e) { /* no-op */ }
  }

  /* ============================================================
     Picker instance
     ============================================================ */
  function Picker(root) {
    this.root = root;
    this.configId = root.getAttribute('data-config');
    this.entry = root.getAttribute('data-entry') || (new URLSearchParams(location.search).get('src')) || 'direct';
    this.config = (window.KSUPickerConfigs || {})[this.configId];
    var dataEl = root.querySelector('[data-ksu-picker-products]');
    this.products = dataEl ? JSON.parse(dataEl.textContent) : {};
    if (!this.config) return;

    this.answers = {};           // { qKey: [values] }
    this.stepIndex = 0;
    this.chosenVariant = {};     // handle -> variantId (color pick)
    this.stage = root.querySelector('[data-ksu-picker-stage]');
    this.started = false;

    this.readURL();
    if (this.hasFullURLState()) {
      this.showResult(this.config.resolve(this.answers, this.helpers()));
    } else {
      this.showQuestion(0);
    }
    this.bindCurrency();
    this.bindCompare();
  }

  Picker.prototype.helpers = function () {
    var self = this;
    return {
      has: function (q, v) { return (self.answers[q] || []).indexOf(v) > -1; },
      hasAny: function (q, vals) {
        return vals.some(function (v) { return (self.answers[q] || []).indexOf(v) > -1; });
      }
    };
  };

  /* ---------- Question flow ---------- */
  Picker.prototype.visibleQuestions = function () {
    var self = this, h = this.helpers();
    return this.config.questions.filter(function (q) {
      return !q.showIf || h.has(q.showIf.q, q.showIf.has);
    });
  };

  Picker.prototype.showQuestion = function (index) {
    var qs = this.visibleQuestions();
    if (index >= qs.length) { this.finish(); return; }
    this.stepIndex = index;
    var q = qs[index];
    var self = this;
    var selected = this.answers[q.key] || [];

    if (!this.started) {
      this.started = true;
      ga('picker_start', { picker: this.configId, picker_entry: this.entry });
    }
    ga('picker_question_view', { picker: this.configId, question: q.key, step: index + 1, picker_entry: this.entry });

    var isMulti = q.type === 'multi';
    var optsHtml = q.options.map(function (o) {
      var on = selected.indexOf(o.value) > -1;
      return '<li><button type="button" class="ksu-picker__opt' + (isMulti ? '' : ' ksu-picker__opt--radio') + '" ' +
        (isMulti ? 'aria-pressed' : 'role="radio" aria-checked') + '="' + on + '" data-value="' + esc(o.value) + '">' +
        '<span class="ksu-picker__opt-check">' + CHECK_SVG + '</span>' +
        '<span><span class="ksu-picker__opt-label">' + esc(o.label) + '</span>' +
        (o.micro ? '<span class="ksu-picker__opt-micro">' + esc(o.micro) + '</span>' : '') +
        '</span></button></li>';
    }).join('');

    this.stage.innerHTML =
      '<div class="ksu-picker__meta">' +
      '  <span class="ksu-picker__progress">Question ' + (index + 1) + ' of ' + qs.length + '</span>' +
      '  <button type="button" class="ksu-picker__compare-link" data-compare-open>Compare all variants</button>' +
      '</div>' +
      '<h3 class="ksu-picker__q-title" id="kp-q-' + esc(q.key) + '">' + esc(q.title) + '</h3>' +
      (q.sub ? '<p class="ksu-picker__q-sub">' + esc(q.sub) + '</p>' : '') +
      '<ul class="ksu-picker__opts' + (q.options.length > 4 ? ' ksu-picker__opts--cols' : '') + '"' +
      (isMulti ? '' : ' role="radiogroup" aria-labelledby="kp-q-' + esc(q.key) + '"') + '></ul>' +
      '<div class="ksu-picker__nav">' +
      (index > 0 ? '<button type="button" class="ksu-picker__back">&larr; Back</button>' : '<span></span>') +
      '<button type="button" class="ksu-picker__next" ' + (selected.length ? '' : 'disabled') + '>' +
      (index + 1 === qs.length ? 'See my match' : 'Next') + '</button>' +
      '</div>';

    this.stage.querySelector('.ksu-picker__opts').innerHTML = optsHtml;

    var nextBtn = this.stage.querySelector('.ksu-picker__next');
    this.stage.querySelectorAll('.ksu-picker__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-value');
        var cur = self.answers[q.key] || [];
        if (isMulti) {
          var i = cur.indexOf(v);
          if (i > -1) cur.splice(i, 1); else cur.push(v);
          self.answers[q.key] = cur;
          btn.setAttribute('aria-pressed', String(cur.indexOf(v) > -1));
        } else {
          self.answers[q.key] = [v];
          self.stage.querySelectorAll('.ksu-picker__opt').forEach(function (b) {
            b.setAttribute('aria-checked', String(b === btn));
          });
        }
        // Q1 answers can reveal/hide the conditional follow-up; labels may flip.
        var vq = self.visibleQuestions();
        nextBtn.disabled = !(self.answers[q.key] || []).length;
        nextBtn.textContent = (self.stepIndex + 1 === vq.length) ? 'See my match' : 'Next';
        var prog = self.stage.querySelector('.ksu-picker__progress');
        if (prog) prog.textContent = 'Question ' + (self.stepIndex + 1) + ' of ' + vq.length;
      });
    });

    var back = this.stage.querySelector('.ksu-picker__back');
    if (back) back.addEventListener('click', function () { self.showQuestion(index - 1); });
    nextBtn.addEventListener('click', function () { self.showQuestion(index + 1); });
    this.bindCompare();
  };

  Picker.prototype.finish = function () {
    this.writeURL();
    var outcome = this.config.resolve(this.answers, this.helpers());
    this.pushKlaviyoAnswers(outcome);
    this.showResult(outcome);
  };

  /* ---------- Trade-off card ---------- */
  Picker.prototype.showTradeoff = function (outcome) {
    var self = this;
    var t = this.config.tradeoff(outcome.context || {}, this.helpers());
    ga('picker_tradeoff_view', { picker: this.configId, picker_entry: this.entry });

    this.stage.innerHTML =
      '<div class="ksu-picker__meta">' +
      '  <span class="ksu-picker__progress">One more call to make</span>' +
      '  <button type="button" class="ksu-picker__compare-link" data-compare-open>Compare all variants</button>' +
      '</div>' +
      '<h3 class="ksu-picker__q-title">' + esc(t.title) + '</h3>' +
      '<p class="ksu-picker__tradeoff-note">' + t.note + '</p>' +
      '<ul class="ksu-picker__opts"></ul>' +
      '<div class="ksu-picker__nav"><button type="button" class="ksu-picker__back">&larr; Back</button><span></span></div>';

    var list = this.stage.querySelector('.ksu-picker__opts');
    t.options.forEach(function (o, i) {
      var btn = el('<li><button type="button" class="ksu-picker__opt ksu-picker__opt--radio" aria-checked="false">' +
        '<span class="ksu-picker__opt-check">' + CHECK_SVG + '</span>' +
        '<span><span class="ksu-picker__opt-label">' + esc(o.label) + '</span>' +
        (o.micro ? '<span class="ksu-picker__opt-micro">' + esc(o.micro) + '</span>' : '') +
        '</span></button></li>');
      btn.querySelector('button').addEventListener('click', function () {
        ga('picker_tradeoff_choice', { picker: self.configId, choice: i, picker_entry: self.entry });
        self.showResult(o.outcome);
      });
      list.appendChild(btn);
    });
    this.stage.querySelector('.ksu-picker__back').addEventListener('click', function () {
      self.showQuestion(self.visibleQuestions().length - 1);
    });
    this.bindCompare();
  };

  /* ---------- Result ---------- */
  Picker.prototype.product = function (key) {
    var handle = this.config.skus[key];
    return this.products[handle] ? Object.assign({ key: key, handle: handle }, this.products[handle]) : null;
  };
  Picker.prototype.variantFor = function (p) {
    if (this.chosenVariant[p.handle]) {
      var pick = p.variants.filter(function (v) { return v.id === this.chosenVariant[p.handle]; }, this)[0];
      if (pick) return pick;
    }
    var avail = p.variants.filter(function (v) { return v.available; });
    return avail[0] || p.variants[0];
  };

  Picker.prototype.showResult = function (outcome) {
    if (!outcome) return;
    if (outcome.type === 'tradeoff') { this.showTradeoff(outcome); return; }
    var self = this;
    var primary = this.product(outcome.primary);
    if (!primary) return;
    var pv = this.variantFor(primary);
    var why = (outcome.why || []).slice(0, 4);

    ga('picker_complete', {
      picker: this.configId,
      recommended_sku: primary.handle,
      picker_entry: this.entry
    });

    var countryCode = this.root.getAttribute('data-country') || '';
    var shipDest = countryCode ? ' to ' + countryCode + ' ' + flagEmoji(countryCode) : '';

    var variantPills = '';
    var realVariants = primary.variants.filter(function (v) { return v.title && v.title !== 'Default Title'; });
    if (realVariants.length > 1) {
      variantPills = '<div class="ksu-picker__variants" role="group" aria-label="Choose a color">' +
        realVariants.map(function (v) {
          return '<button type="button" class="ksu-picker__variant-pill" data-variant="' + v.id + '" aria-pressed="' + (v.id === pv.id) + '"' +
            (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — sold out') + '</button>';
        }).join('') + '</div>';
    }

    var stockHtml = pv.available
      ? '<div class="ksu-picker__stock"><span class="ksu-picker__stock-dot"></span>In stock &mdash; ships free over $100' + shipDest + '</div>'
      : '<div class="ksu-picker__stock ksu-picker__stock--out"><span class="ksu-picker__stock-dot"></span><b>Sold out</b>&nbsp;&mdash; get notified the moment it&rsquo;s back</div>';

    var buyHtml;
    if (pv.available) {
      buyHtml =
        '<button type="button" class="ksu-picker__cta" data-atc data-items=\'' + JSON.stringify([{ id: pv.id, quantity: 1 }]) + '\'>' +
        CART_SVG +
        '<span class="ksu-picker__cta-labels"><span>Add to cart &mdash; <span data-price-cents="' + pv.price + '">' + formatPrice(pv.price) + '</span></span>' +
        '<span class="ksu-picker__cta-sub">100-day money-back guarantee</span></span>' +
        '</button>';
    } else {
      buyHtml =
        '<form class="ksu-picker__notify" data-notify>' +
        '<div class="ksu-picker__notify-row">' +
        '<input class="ksu-picker__notify-input" type="email" name="email" placeholder="you@example.com" required aria-label="Email for restock alert">' +
        '<input type="hidden" name="variant_id" value="' + pv.id + '">' +
        '<button class="ksu-picker__notify-btn" type="submit">Notify me</button>' +
        '</div>' +
        '<p class="ksu-picker__notify-status ksu-picker__notify-status--ok">&#10003; You&rsquo;re on the list &mdash; we&rsquo;ll email you the moment it&rsquo;s back.</p>' +
        '<p class="ksu-picker__notify-status ksu-picker__notify-status--err">Something went wrong &mdash; try again or email support@kensui.com.</p>' +
        '</form>';
    }

    var altsHtml = (outcome.alts || []).map(function (a) {
      var ap = a.sku ? self.product(a.sku) : null;
      var text = a.text.replace('{name}', ap ? esc(ap.title) : '').replace('{price}', ap ? formatPrice(self.variantFor(ap).price) : '');
      if (ap && a.switchTo) {
        return '<div class="ksu-picker__alt">' + text + ' <button type="button" data-switch="' + esc(a.sku) + '" data-alt-index="' + (outcome.alts || []).indexOf(a) + '">See it as my match &rarr;</button></div>';
      }
      return '<div class="ksu-picker__alt">' + text + (ap ? ' <a href="' + esc(ap.url) + '">View ' + esc(ap.title) + '</a>' : '') + '</div>';
    }).join('');

    var tiersHtml = this.buildTiers(outcome);

    this.stage.innerHTML =
      '<p class="ksu-picker__result-eyebrow">' + esc(outcome.eyebrow || 'Your match') + '</p>' +
      '<div class="ksu-picker__primary">' +
      '  <div class="ksu-picker__primary-img">' + (primary.image ? '<img src="' + esc(primary.image) + '" alt="' + esc(primary.title) + '" loading="lazy" width="336" height="336">' : '') + '</div>' +
      '  <div>' +
      '    <h3 class="ksu-picker__primary-name"><a href="' + esc(primary.url) + '">' + esc(primary.title) + '</a></h3>' +
      '    <div class="ksu-picker__price-row">' +
      '      <span class="ksu-picker__price" data-price-cents="' + pv.price + '">' + formatPrice(pv.price) + '</span>' +
      (pv.compare_at_price > pv.price ? '<span class="ksu-picker__compare-at" data-price-cents="' + pv.compare_at_price + '">' + formatPrice(pv.compare_at_price) + '</span>' : '') +
      '    </div>' +
      stockHtml + variantPills +
      '    <ul class="ksu-picker__why">' + why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' +
      buyHtml +
      '  </div>' +
      '</div>' +
      altsHtml +
      tiersHtml +
      '<div class="ksu-picker__guarantee">' + SHIELD_SVG +
      '  <span><b>Train with it for 100 days.</b>If it doesn&rsquo;t earn its spot, send it back for a full refund.</span>' +
      '</div>' +
      '<div class="ksu-picker__email-build" data-email-build>' +
      '  <p class="ksu-picker__email-build-label">Want this build in your inbox?</p>' +
      '  <form class="ksu-picker__notify" data-email-build-form>' +
      '    <div class="ksu-picker__notify-row">' +
      '      <input class="ksu-picker__notify-input" type="email" name="email" placeholder="you@example.com" required aria-label="Email me this build">' +
      '      <button class="ksu-picker__notify-btn" type="submit">Email me this build</button>' +
      '    </div>' +
      '    <p class="ksu-picker__notify-status ksu-picker__notify-status--ok">&#10003; Sent to your Klaviyo profile &mdash; check your inbox shortly.</p>' +
      '    <p class="ksu-picker__notify-status ksu-picker__notify-status--err">Something went wrong &mdash; please try again.</p>' +
      '  </form>' +
      '</div>' +
      '<div class="ksu-picker__meta" style="margin-top:14px">' +
      '  <button type="button" class="ksu-picker__redo" data-redo>Start over</button>' +
      '  <button type="button" class="ksu-picker__compare-link" data-compare-open>Compare all variants</button>' +
      '</div>';

    /* variant pills */
    this.stage.querySelectorAll('.ksu-picker__variant-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        self.chosenVariant[primary.handle] = parseInt(pill.getAttribute('data-variant'), 10);
        self.showResult(outcome);
      });
    });
    /* alt switch */
    this.stage.querySelectorAll('[data-switch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = (outcome.alts || [])[parseInt(b.getAttribute('data-alt-index'), 10)] || {};
        var alt = Object.assign({}, outcome, {
          primary: b.getAttribute('data-switch'),
          alts: outcome.altsWhenSwitched || [],
          why: src.whySwitched || outcome.why
        });
        self.showResult(alt);
      });
    });
    /* ATC buttons */
    this.stage.querySelectorAll('[data-atc]').forEach(function (b) { self.bindATC(b, outcome); });
    /* BIS */
    var notify = this.stage.querySelector('[data-notify]');
    if (notify) this.bindNotify(notify);
    /* email me this build */
    var eb = this.stage.querySelector('[data-email-build-form]');
    if (eb) this.bindEmailBuild(eb, outcome, primary);
    /* redo */
    this.stage.querySelector('[data-redo]').addEventListener('click', function () {
      self.answers = {}; self.writeURL(true); self.showQuestion(0);
    });
    this.bindCompare();
  };

  /* ---------- Tiers ---------- */
  Picker.prototype.buildTiers = function (outcome) {
    var self = this;
    var tiers = this.config.tiers(outcome, this.helpers());
    if (!tiers || !tiers.length) return '';
    var cells = tiers.map(function (tier, i) {
      var items = tier.skus.map(function (k) { return self.product(k); }).filter(Boolean);
      if (!items.length) return '';
      var total = 0, atcItems = [], allAvail = true;
      var lis = items.map(function (p) {
        var v = self.variantFor(p);
        total += v.price;
        if (!v.available) allAvail = false;
        atcItems.push({ id: v.id, quantity: 1 });
        return '<li>' + esc(p.title) + '</li>';
      }).join('');
      return '<div class="ksu-picker__tier' + (tier.featured ? ' ksu-picker__tier--featured' : '') + '">' +
        (tier.featured ? '<span class="ksu-picker__tier-badge">Most picked</span>' : '') +
        '<span class="ksu-picker__tier-name">' + esc(tier.name) + '</span>' +
        '<ul class="ksu-picker__tier-items">' + lis + '</ul>' +
        (tier.blurb ? '<span class="ksu-picker__tier-blurb">' + esc(tier.blurb) + '</span>' : '') +
        '<span class="ksu-picker__tier-price" data-price-cents="' + total + '">' + formatPrice(total) + '</span>' +
        (allAvail
          ? '<button type="button" class="ksu-picker__cta" data-atc data-tier="' + esc(tier.name) + '" data-items=\'' + JSON.stringify(atcItems) + '\'>' + CART_SVG + '<span>Add to cart</span></button>'
          : '<button type="button" class="ksu-picker__cta" disabled>Part of this set is sold out</button>') +
        '</div>';
    }).join('');
    return '<h4 class="ksu-picker__tiers-title">Build it your way</h4><div class="ksu-picker__tiers">' + cells + '</div>';
  };

  /* ---------- AJAX add-to-cart → existing cart drawer ---------- */
  Picker.prototype.bindATC = function (btn, outcome) {
    var self = this;
    btn.addEventListener('click', function () {
      var items;
      try { items = JSON.parse(btn.getAttribute('data-items')); } catch (e) { return; }
      btn.setAttribute('data-state', 'adding');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('atc ' + res.status);
        return res.json();
      }).then(function () {
        btn.setAttribute('data-state', 'added');
        setTimeout(function () { btn.removeAttribute('data-state'); }, 2500);
        ga('add_to_cart', {
          picker: self.configId,
          picker_tier: btn.getAttribute('data-tier') || 'primary',
          recommended_sku: self.config.skus[outcome.primary],
          picker_entry: self.entry
        });
        /* Theme cart drawer refreshes + opens on this event (BUNDLE_MAP /
           free-shipping bar run unmodified inside the drawer itself). */
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }).catch(function () {
        btn.removeAttribute('data-state');
        window.location.href = '/cart';
      });
    });
  };

  /* ---------- Klaviyo back-in-stock (existing KENSUI pattern) ---------- */
  Picker.prototype.bindNotify = function (form) {
    var KLAVIYO_PUBLIC_KEY = this.root.getAttribute('data-klaviyo-key') || 'QeupfE';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[name="email"]').value || '').trim();
      var variantId = form.querySelector('input[name="variant_id"]').value;
      if (!email || !variantId) { form.setAttribute('data-state', 'error'); return; }
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      }).then(function (res) {
        form.setAttribute('data-state', (res.ok || res.status === 202) ? 'success' : 'error');
      }).catch(function () { form.setAttribute('data-state', 'error'); });
    });
  };

  /* ---------- Klaviyo profile properties + "email me this build" ---------- */
  Picker.prototype.pushKlaviyoAnswers = function (outcome) {
    var props = {}, self = this;
    this.config.questions.forEach(function (q) {
      if ((self.answers[q.key] || []).length) {
        props[self.configId + '_' + (q.klaviyoProp || q.key)] = self.answers[q.key].join(',');
      }
    });
    if (outcome && outcome.primary) props[this.configId + '_recommended'] = this.config.skus[outcome.primary];
    klaviyoPush(['track', 'Completed Product Picker', Object.assign({ picker: this.configId, entry: this.entry }, props)]);
  };
  Picker.prototype.bindEmailBuild = function (form, outcome, primary) {
    var self = this;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[name="email"]').value || '').trim();
      if (!email) { form.setAttribute('data-state', 'error'); return; }
      klaviyoPush(['identify', { email: email }]);
      klaviyoPush(['track', 'Requested Picker Build Email', {
        picker: self.configId,
        recommended_sku: primary.handle,
        recommended_url: location.origin + primary.url,
        picker_url: location.href
      }]);
      self.pushKlaviyoAnswers(outcome);
      form.setAttribute('data-state', 'success');
      ga('picker_email_build', { picker: self.configId, picker_entry: self.entry });
    });
  };

  /* ---------- URL state ---------- */
  Picker.prototype.readURL = function () {
    var params = new URLSearchParams(location.search);
    var self = this;
    this.config.questions.forEach(function (q) {
      var raw = params.get(q.urlParam || q.key);
      if (!raw) return;
      var valid = q.options.map(function (o) { return o.value; });
      var vals = raw.split(',').filter(function (v) { return valid.indexOf(v) > -1; });
      if (vals.length) self.answers[q.key] = q.type === 'single' ? [vals[0]] : vals;
    });
  };
  Picker.prototype.hasFullURLState = function () {
    var self = this;
    return this.visibleQuestions().every(function (q) { return (self.answers[q.key] || []).length; }) &&
      Object.keys(this.answers).length > 0;
  };
  Picker.prototype.writeURL = function (clear) {
    var params = new URLSearchParams(location.search);
    var self = this;
    this.config.questions.forEach(function (q) {
      var p = q.urlParam || q.key;
      var vals = self.answers[q.key] || [];
      if (clear || !vals.length) params.delete(p);
      else params.set(p, vals.join(','));
    });
    var qs = params.toString();
    try {
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) { /* sandboxed contexts (previews) disallow replaceState */ }
  };

  /* ---------- Currency re-render ---------- */
  Picker.prototype.bindCurrency = function () {
    var self = this;
    document.addEventListener('currency:changed', function () {
      self.stage.querySelectorAll('[data-price-cents]').forEach(function (n) {
        n.textContent = formatPrice(parseInt(n.getAttribute('data-price-cents'), 10));
      });
    });
  };

  /* ---------- Compare-all modal ---------- */
  Picker.prototype.bindCompare = function () {
    var self = this;
    this.root.querySelectorAll('[data-compare-open]').forEach(function (b) {
      if (b._kpBound) return;
      b._kpBound = true;
      b.addEventListener('click', function () { self.openCompare(); });
    });
  };
  Picker.prototype.openCompare = function () {
    var self = this;
    ga('picker_compare_view', { picker: this.configId, picker_entry: this.entry });
    var existing = document.querySelector('.ksu-picker__modal');
    if (existing) existing.remove();

    var cmp = this.config.compare;
    var rows = cmp.rows.map(function (r) {
      var p = self.product(r.sku);
      if (!p) return '';
      var v = self.variantFor(p);
      var cells = cmp.columns.map(function (c) {
        var val = r.attrs[c.key];
        if (val === true) return '<td class="kp-yes">&#10003;</td>';
        if (val === false || val == null) return '<td class="kp-no">&mdash;</td>';
        return '<td>' + esc(val) + '</td>';
      }).join('');
      return '<tr><td><a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + (v.available ? '' : '<br><small>Sold out</small>') + '</td>' +
        '<td data-price-cents="' + v.price + '">' + formatPrice(v.price) + '</td>' + cells + '</tr>';
    }).join('');

    var modal = el(
      '<div class="ksu-picker ksu-picker__modal" role="dialog" aria-modal="true" aria-label="Compare all variants">' +
      '<div class="ksu-picker__modal-overlay" data-close></div>' +
      '<div class="ksu-picker__modal-panel">' +
      '<button type="button" class="ksu-picker__modal-close" data-close aria-label="Close">&times;</button>' +
      '<h4 class="ksu-picker__modal-title">' + esc(cmp.title || 'Compare all variants') + '</h4>' +
      '<div class="ksu-picker__table-wrap"><table class="ksu-picker__table">' +
      '<thead><tr><th>Model</th><th>Price</th>' + cmp.columns.map(function (c) { return '<th>' + esc(c.label) + '</th>'; }).join('') + '</tr></thead>' +
      '<tbody>' + rows + '</tbody></table></div>' +
      '</div></div>');
    modal.style.background = 'none';
    modal.style.border = 'none';
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-close]').forEach(function (c) {
      c.addEventListener('click', function () { modal.remove(); });
    });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') { modal.remove(); document.removeEventListener('keydown', onEsc); }
    });
  };

  /* ---------- Boot ---------- */
  function boot() {
    document.querySelectorAll('[data-ksu-picker]').forEach(function (root) {
      if (!root._kpInit) { root._kpInit = true; new Picker(root); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();